import { useMemo } from 'react';
import { formatDate, IChain } from '@sc1/common';
import { createMarker, TMarker } from '../utils';

const LIQUIDATION = 'Loan Liquidation';
const LENDING_EXPLOIT = 'Lending Protocol Exploit';

interface IEvent {
  title: string;
  marker: TMarker;
  description: string;
}

type TEvents = Partial<Record<IChain, Record<string, IEvent[]>>>;

const dateFromTime = (x) => formatDate(new Date(x * 1000), 'DD MMM, YYYY');

const events: TEvents = {
  fantom: {
    ['0x3938411fd77A5458721aF6B080b51008394568ef'.toLowerCase()]: [
      {
        title: LENDING_EXPLOIT + ': ' + dateFromTime(1652814033),
        marker: createMarker(1652814033, LENDING_EXPLOIT),
        description: `\
          Fantom lending market Scream was drained of funds after\
          the DEI depeg due to them hardcoding its value to $1.\
          Because a strategy in Scion's Fantom vault was using this\
          lending market, its funds were suffered a temporary loss.
          
          Scion was able to retrieve all funds shortly after by building a\
          bot to listen for all incoming USDC transfers to the cToken\
          contract and use it to redeem the remaining Scream USDC\
          cTokens in the strategy.\
        `,
      },
    ],
  },
  moonriver: {
    ['0xc24d43093b44b7a9657571ddb79fedf014eaef7d'.toLowerCase()]: [
      {
        title: LIQUIDATION + ': ' + dateFromTime(1647327738),
        marker: createMarker(1647327738, LIQUIDATION),
        description: `\
          Due to a logic error in the server's code,\
          Scion's keeper bot failed to detect dangerous\
          loan health caused by a spike in the MOVR price.\
          The rebalance also reverted due to a large difference\
          between the swap price and oracle price, an assertion\
          intended to protect rebalances from sandwich attacks.

          Steps taken to mitigate future liquidations:
          All logic errors have been fixed and tests added.\
          Rebalance methods now accept slippage parameters to\
          ensure that rebalances will always execute while\
          still remaining protected from flash swap attacks.\
        `,
      },
      {
        title: LIQUIDATION + ': ' + dateFromTime(1656064938),
        marker: createMarker(1656064938, LIQUIDATION),
        description: `\
          A 30% MOVR price jump resulted in the liquidation of the strategy's loan balance.\
          The keeper bot attempted to rebalance,\
          but the transaction wasn't included until one block after the\
          liquidation transaction.

          Steps taken to mitigate future liquidations:
          Safe collateral ratios have been reduced and\
          the minimum loan health required to trigger a rebalance have been\
          increased. This ensures that the loans are both, healthier from the start\
          and rebalance sooner than before.\
          We have also added Gelato bots that monitor the loan health. 
        `,
      },
    ],
  },
};

export const useSeriesEvents = (chain: IChain, address: string) => {
  return useMemo(() => {
    const allEvents = events[chain]?.[address?.toLowerCase()];
    return {
      events: allEvents,
      markers: allEvents?.map((x) => x.marker),
    };
  }, [chain, address]);
};
